const IMAGE_EXTENSIONS = new Set([
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "bmp",
  "svg",
  "heic",
  "heif",
]);

const NON_IMAGE_EXTENSIONS = new Set([
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "zip",
  "rar",
]);

export const getFileExtension = (url) => {
  const path = String(url || "")
    .split("?")[0]
    .split("#")[0];
  const fileName = path.split("/").pop() || "";
  const dotIndex = fileName.lastIndexOf(".");
  if (dotIndex < 0) return "";
  return fileName.slice(dotIndex + 1).toLowerCase();
};

/** Treat as image when extension is known image, or unknown (common upload paths). */
export const isImageFile = (url) => {
  const ext = getFileExtension(url);
  if (!ext) return true;
  if (NON_IMAGE_EXTENSIONS.has(ext)) return false;
  return IMAGE_EXTENSIONS.has(ext);
};

export const isPdfFile = (url) => getFileExtension(url) === "pdf";
